import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChild, ElementRef, Renderer2, ViewChild } from "@angular/core";
import { CsLabelComponent } from '../cs-label/cs-label';

@Component({
    selector: 'cs-item-list-header',
    templateUrl: 'cs-item-list-header.html',
    host: { 'class': 'item-list-header' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsItemListHeaderComponent implements AfterContentInit {
    @ContentChild(CsLabelComponent) csLabelContent: CsLabelComponent;
    @ViewChild('labelWrapper', { static: false }) labelWrapper: ElementRef;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2
    ) {}

    ngAfterContentInit() {
        // Check if there's text content that's not wrapped in cs-label
        const el = this.elementRef.nativeElement;
        const hasDirectTextContent = Array.from(el.childNodes).some((node: Node) =>
            node.nodeType === Node.TEXT_NODE && node.textContent?.trim()
        );

        // If there's already a cs-label or no direct text, remove the wrapper cs-label
        if (this.csLabelContent || !hasDirectTextContent) {
            const wrapperLabel = el.querySelector('.label-wrapper > cs-label:first-child');
            if (wrapperLabel && !wrapperLabel.textContent?.trim()) {
                this.renderer.removeChild(wrapperLabel.parentNode, wrapperLabel);
            }
        }
    }
}